import { getTokenUser } from "commons/apis/authClient";
import { tipsColor } from "constraints/PlanEnum";
import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";

const CartTips = (props) => {
  const { data } = props;
  console.log("data tips", data);
  const { t } = useTranslation();
  const { roleLevel } = getTokenUser();

  const formattedData = useMemo(() => {
    if (roleLevel !== 4) {
      const depositedItem = data.find(
        (item) => item.statusName === "Deposited"
      );
      const completeItem = data.find((item) => item.statusName === "Complete");

      if (depositedItem && completeItem) {
        return data
          .map((item) => {
            if (item.statusName === "Deposited") {
              return {
                ...item,
                count: depositedItem.count + completeItem.count,
                percentage: depositedItem.percentage + completeItem.percentage,
              };
            }
            if (item.statusName === "Complete") {
              return null;
            }
            return item;
          })
          .filter(Boolean);
      }
    }

    return data;
  }, [data, roleLevel]);

  const formatStatus = useCallback(
    (statusName) => {
      if (roleLevel !== 4 && statusName === "Complete") {
        return "Deposited";
      }
      return statusName;
    },
    [roleLevel]
  );

  return (
    <div className="stacking-tips">
      <div className="stacking-tips-container">
        <div className="stacking-tips-header">
          <div />
          <p>{t("winners.status")}</p>
          <p>{t("winners.quantity")}</p>
          <p>{t("winners.percentage")}</p>
        </div>
        <div className="stacking-tips-body">
          {formattedData.map((item, index) => {
            return (
              <div className="stacking-tips-row" key={index}>
                <div
                  style={{
                    marginLeft: "0.5rem",
                    backgroundColor: tipsColor[formatStatus(item.statusName)],
                    border: "1px solid #7075ae",
                  }}
                />
                <p>{t(`winners.${formatStatus(item.statusName)}`)}</p>
                <p>{item.count}</p>
                <p>{item.percentage}%</p>
              </div>
            );
          })}
          <div className="stacking-tips-row">
            <div />
            <p>Tổng</p>
            <p>{data.reduce((acc, item) => acc + item.count, 0)}</p>
            <p>
              {Math.ceil(data.reduce((acc, item) => acc + item.percentage, 0))}%
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartTips;
